import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import t from '@rcm/i18n-client';
import { useDispatch } from 'react-redux';
import { close } from '../../actions';

interface Props {
    disabled?: boolean;
}

const CloseButton = (props: Props) => {
    const dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(close());
    }, []);

    return <Button
        disabled={props.disabled}
        onClick={handleClick}
    >{t('Done')}</Button>
}

export default CloseButton;
